export const VERSION = '4.73.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map